<template>
  <div class="pneu-medida ml-4 mr-4">
    <b-form>
      <b-row>
        <!-- -->

        <b-col cols="1">
          <br />
          <b-button
            variant="warning"
            class="ml-5 mt-2"
            v-b-modal.modal-multi-medida
            @click="reset()"
            >Novo</b-button
          >
        </b-col>
      </b-row>
    </b-form>

    <div class="d-flex justify-content-center mb-3"></div>
    <!--tbl de dados -->
    <b-table
      id="medida"
      small
      hover
      striped
      sticky-header="550px"
      :items="medida"
      :fields="fields"
    >
      <template slot="cell(actions)" slot-scope="data">
        <b-button
          @click="editmedida(data.item)"
          title="Editar medida"
          size="sm"
          variant="primary"
          class="mr-2 mt-2"
          v-b-modal.modal-multi-medida
        >
          <i class="fa fa-exclamation-circle"></i>
        </b-button>
      </template>
    </b-table>

    <!--  MODAL GRAVAÇÃO RELACAO DA medida pneu -->
    <!--  MODAL GRAVAÇÃO RELACAO DA medida pneu -->
    <div>
      <b-modal
        id="modal-multi-medida"
        hide-footer
        size="lg"
        title="Cadastro de medidas"
      >
        <!-- -->
        <div>
          <b-row>
            <b-col cols="6">
              <label for="input-filial">Empresa</label>
              <div>
                <b-form-select
                  id="fun-empresa"
                  v-model="med.empresa_id"
                  required
                  :options="empresas"
                  class="mb-3"
                  text-field="empresa"
                >
                </b-form-select>
              </div>
            </b-col>

            <b-col cols="6">
              <label for="input-live">medida</label>
              <b-form-input
                v-model="med.medida"
                placeholder="Digite a descrição do medida"
              ></b-form-input>
            </b-col>
          </b-row>
          <input id="id-medida" type="hidden" v-model="med.id" />

          <b-button
            class="mt-3"
            variant="success"
            block
            @click="postmedida(), reset()"
            >Gravar</b-button
          >
        </div>
      </b-modal>
    </div>
    <!--  MODAL GRAVAÇÃO RELACAO DA FROTA INDISPONIVEL -->
  </div>
</template>


<script>
import { baseApiUrl, showError } from "@/global";
import axios from "axios";
import moment from "moment";
import { mapState } from "vuex";

export default {
  computed: { ...mapState(["user"]) },
  name: "Manutencaomedida",

  data: function () {
    return {
      carregando: false,
      empresas: [],
      med: {},
      medida: [], // [] lista

      //  barra_inicial: 0,
      //  barra_limite: 300000,

      fields: [
        { key: "empresa_id", label: "Empresa", sortable: true },
        { key: "id", label: "Id", sortable: true },
        { key: "medida", label: "medida", sortable: true },
        {
          key: "dt_cadastro",
          label: "Data Cadastro",
          sortable: true,
          formatter: (value, key, medida) => {
            return moment(medida.dt_cadastro)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        {
          key: "dt_alteracao",
          label: "Data Alteracao",
          sortable: true,
          formatter: (value, key, medida) => {
            return moment(medida.dt_alteracao)
              .format("DD/MM/YYYY - HH:mm")
              .replace("Data inválida", "-");
          },
        },
        { key: "actions", label: "Ações" },
      ],
    };
  },

  components: {},
  methods: {
    loadEmpresa() {
      let params = {
        psg: this.user.psg,
        id_grupo_empresa: `${this.user.id_grupo_empresa}`,
      };

      const url = `${baseApiUrl}/ctr/empresa`;
      axios
        .get(url, { params })
        .then((res) => {
          this.empresas = res.data.map((emp) => {
            return {
              ...emp,
              value: emp.id_empresa,
              empresa: emp.nomeempresarial,
              id_filial_erp: emp.id_filial_erp,
            };
          });
        })
        .catch(showError);
    },

    loadmedida() {
      let params = {
        empresa_id: `${this.user.id_empresa}`,
        psg: this.user.psg,
      };
      const url = `${baseApiUrl}/pneu/medida`;
      axios.get(url, { params }).then((res) => {
        this.medida = res.data.map((med) => {
          return { ...med };
        });
      });
    },

    editmedida(med) {
      this.med = { ...med };
      this.loadEmpresa();
    },

    postmedida() {
      let corpo = {
        psg: this.user.psg,
        empresa_id: `${this.med.empresa_id}`,
        id_funcionario: `${this.user.id_funcionario}`,
        id: `${this.med.id}`,
        medida: `${this.med.medida}`,
      };

      const url = `${baseApiUrl}/pneu/medidacad`;

      axios
        .post(url, corpo)
        .then(() => {
          this.$toasted.global.defaultSuccess();
          this.reset(); //limpar os objetos valores
        })
        .catch(showError);
    },

    reset() {
      this.med = {};
      this.medida = [];
      this.loadmedida();
    },
  },

  mounted() {
    this.loadEmpresa();
    this.loadmedida(); //    se habilitado carrega o grid
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>
#selecaostatusx {
  font-size: 0.7em;
}

#medidas {
  font-size: 0.9em;
  text-align: center;
}
</style>